import React from 'react';

export enum InstitutionContextKeys {
    none = 'none',
    manageInstitution = 'manageInstitution',
}

export const InstitutionContext = React.createContext(InstitutionContextKeys.none);

export interface Institution {
    org_client_nbr: string,
    org_guid: string,

    known_as: string,
    organization_name: string,
    physical_address_1: string,
    physical_address_2: string,
    physical_address_3: string,
    physical_city: string,
    physical_state: string,
    physical_postal_code: string,
    physical_country: string,
    physical_address_expiration_date: string,
    business_email_address: string,
    business_phone_country_code: string,
    business_phone_area_code: string,
    business_phone_number: string, 
    business_phone_extension: string,
    fax_phone_country_code: string,
    fax_phone_area_code: string,
    fax_phone_number: string,
    fax_phone_extension: string,
    website_url: string,
    billing_address_1: string,
    billing_address_2: string,
    billing_address_3: string,
    billing_city: string,
    billing_state: string,
    billing_postal_code: string,
    billing_country: string,
    billing_address_expiration_date: string,

    school_indicator?: string,
    seasonal_institution?: string,
    sunday_school_indicator?: string,
    org_type?: string,
    service_times?: string,
    seating_capacity?: string,
    welcome_mission_statement?: string,
    special_programs?: string,
    parish_description?: string,
    founded_year?: string,
    congregation_size?: number,
    // non-api fields
    business_phone_formatted: string,
    fax_phone_formatted: string,
    province: string,
    provides_lay_pension_plan?: string,
    lay_pension_plan_type?: string,
}